module.exports = __webpack_public_path__ + "img/14.9f6ed894.png";